import Drawer from 'react-modern-drawer';
import { useNavigate } from 'react-router-dom';

import ContainerForm from 'components/ContainerForm';
import { ContainerSection } from 'components/container-section/style';
import { InputTitle } from 'components/input/InputTitle';
import { CustomTable } from 'components/table/style';
import { TagComponent } from 'components/tag/TagComponent';
import {
  AvatarUpload,
  Row,
  Spacing,
  Switch,
  Table,
  Tabs,
  Typography,
  formatDate,
  red,
  updateQueryStateTable,
} from 'enable-ui';

import { RoleKey } from 'modules/auth/core/enum';
import { CustomTabs } from 'modules/classes/styles/tab';
import { HeaderDetailPage } from 'modules/dashboard/components/HeaderDetailPage';
import { TrainerPasswordForm } from 'modules/trainers/component/TrainerPasswordForm';
import { AvatarContainer, Container } from 'modules/trainers/styles/form';

import { CustomAvatar, CustomSwitch } from '../styles/avatar';

import { ReactComponent as ArrowIcon } from 'assets/icons/arrow-up-right.svg';
import { ReactComponent as AvatarIcon } from 'assets/icons/avatar.svg';
import { ReactComponent as UploadIcon } from 'assets/icons/upload.svg';

import { checkRole } from 'helpers';

import { MAX_FILE_SIZE } from 'constants/avatar';
import { COLOR, COLOR_CONFIG } from 'constants/color';
import { PATH } from 'constants/path';
import { TABLE_KEY } from 'constants/table';

import { CfsResultDrawer } from '../component/CfsResultDrawer';
import { FropResultDrawer } from '../component/FropResultDrawer';
import { FunctionalAbilityResult } from '../component/FunctionalAbilityResult';
import { LearnerProfileForm } from '../component/LearnerProfileForm';
import { OnboardingResultDrawer } from '../component/OnboardingResultDrawer';
import { SurveyResultDrawer } from '../component/SurveyResultDrawer';
import { getLearnerResultColumns } from '../core/columns';
import { useLearnerDetailController } from '../core/controller/learner-detail';
import { useLearnerResult } from '../core/controller/learner-result';
import { LEARNER_DETAIL } from '../core/enum';
import { getLearnerDetailTabs } from '../core/tabs';

export const LearnerDetailPage = () => {
  const {
    learnerId,
    nickname,
    name,
    gender,
    phone,
    email,
    dayOfBirth,
    monthOfBirth,
    yearOfBirth,
    height,
    weight,
    bodyFat,
    restingMetabolism,
    skeletalMuscle,
    visceralFatLevel,
    password,
    confirmPassword,
    learner,
    firstName,
    lastName,
    handleChange,
    handleChangeMeasurement,
    onChangeGender,
    handleChangePhone,
    handleConfirmPassword,
    handleSubmit,
    disabled,
    onCancel,
    emailStatus,
    handleChangeDate,
    goBack,
    activeKey,
    onTabClick,
    surveyResult,
    goToCalendar,
    logoRef,
    onChangeAvatar,
    logoURL,
    onErrorAvatar,
    isErrorAvatar,
    onDeleteLogo,
    classes,
    queryState,
    isAccount,
    handleChangeStatus,
    disabledField,
    onChangeMonths,
    onChangeSearchMonths,
    searchSelectMonth,
    onChangeYear,
    onChangeSearchYears,
    searchSelectYear,
    totalTrainingTime,
  } = useLearnerDetailController();

  const navigationTo = useNavigate();

  const isBiologicAdmin = checkRole([RoleKey.BIOLOGIC_ADMIN]);

  const tabs = getLearnerDetailTabs(learnerId ?? '');

  const columns = getLearnerResultColumns();

  const { drawer, handleOpenDrawer, handleCloseDrawer } = useLearnerResult();

  const onClickRow = (row: any) => {
    if (!row?.original?.class?.id || !learnerId) {
      return;
    }

    navigationTo(
      `${PATH.CLASSES}/${PATH.CLASSES_DETAIL.replace(':id', row.original.class.id)}/${PATH.CLASSES_MEMBERS}/${PATH.LEARNER_SCORE.replace(':id', learnerId)}
    `,
      { state: { classId: row.original.class.id } },
    );
  };

  if (!learner) {
    return <></>;
  }

  const renderContent = () => {
    if (activeKey === LEARNER_DETAIL.LESSON_SCHEDULE) {
      return <></>;
    }

    if (activeKey === LEARNER_DETAIL.CLASS_RESULTS) {
      return (
        <CustomTable>
          <Table
            columns={columns}
            dataSource={classes.items}
            total={classes.total}
            tableKey={TABLE_KEY.LEARNER_CLASS_RESULT}
            queryState={{ page: queryState?.page ?? 1, limit: queryState?.limit ?? 10 }}
            updateQueryState={updateQueryStateTable}
            onClickRow={onClickRow}
          />
        </CustomTable>
      );
    }

    return (
      <ContainerForm
        disabled={disabled}
        disabledCancel={disabled}
        onCancel={onCancel}
        onSubmit={handleSubmit}
        titleSubmit="Save"
        titleCancel="Cancel changes"
      >
        <Row direction="row">
          <Spacing spacing="3xl" type="margin" placement="right">
            <CustomAvatar>
              <AvatarUpload
                id="logo-learner"
                size="lg"
                ref={logoRef}
                icon={<UploadIcon />}
                accept=".png,.jpeg,.svg,.webp"
                maxFileSize={MAX_FILE_SIZE}
                onError={onErrorAvatar}
                onChangeFile={onChangeAvatar}
                url={logoURL.value}
                style={{ cursor: disabledField ? 'default' : 'pointer' }}
                disabled={disabledField}
              />
              <label htmlFor="logo-learner">
                <AvatarContainer style={{ cursor: disabledField ? 'default' : 'pointer' }}>
                  <AvatarIcon />
                </AvatarContainer>
              </label>
            </CustomAvatar>

            {isErrorAvatar && (
              <Typography
                weight={600}
                style={{
                  marginTop: 4,
                }}
                color={red['red-5']}
                variant="body-3"
              >{`Max file size is 10Mb`}</Typography>
            )}

            {logoURL.value && !disabledField && (
              <Typography
                variant="body-2"
                style={{
                  whiteSpace: 'nowrap',
                  color: COLOR_CONFIG.red,
                  cursor: 'pointer',
                  textAlign: 'center',
                  marginTop: 8,
                }}
                onClick={onDeleteLogo}
              >
                Remove
              </Typography>
            )}
          </Spacing>
          <Row direction="column">
            <ContainerSection>
              <Row
                direction="column"
                style={{
                  width: 800,
                }}
              >
                <Spacing spacing="md" type="margin" placement="bottom">
                  <Typography
                    weight={500}
                    variant="h4"
                    color={COLOR.surfaceNeutralBold['neutral-11']}
                  >
                    General
                  </Typography>
                </Spacing>
                <Row
                  style={{
                    width: '100%',
                    marginBottom: 24,
                    gap: 24,
                  }}
                >
                  <div style={{ width: '50%' }}>
                    <InputTitle title="Status" />
                    <Row align="center">
                      <CustomSwitch>
                        <Switch
                          checked={learner?.isActive}
                          onClick={handleChangeStatus}
                          disabled={disabledField}
                          className={disabledField ? 'disabled' : ''}
                        ></Switch>
                        <Typography variant="body-2" color={COLOR.surfaceNeutralBold['neutral-11']}>
                          Active
                        </Typography>
                      </CustomSwitch>
                    </Row>
                  </div>
                  <div style={{ width: '50%' }}>
                    <InputTitle title="App account" />
                    <Row align="center">
                      <TagComponent
                        color={learner?.isAccount ? COLOR.green['green-7'] : COLOR_CONFIG.red}
                        text={learner?.isAccount ? 'Created' : 'Not created'}
                      />
                    </Row>
                  </div>
                </Row>
                <Row style={{ width: '100%', marginBottom: 24, gap: 24 }}>
                  {isBiologicAdmin && (
                    <div style={{ width: '50%' }}>
                      <InputTitle title="Institution" />
                      <Row
                        align="center"
                        style={{
                          height: 32,
                        }}
                      >
                        <Typography variant="body-2" color={COLOR.surfaceNeutralBold['neutral-11']}>
                          {learner?.institution?.name || ''}
                        </Typography>
                      </Row>
                    </div>
                  )}
                  <div style={{ width: '50%' }}>
                    <InputTitle title="Level" />
                    <Row
                      align="center"
                      style={{
                        height: 32,
                      }}
                    >
                      {learner.assessmentResult?.levelBFT ? (
                        <Typography variant="body-2" color={COLOR.surfaceNeutralBold['neutral-11']}>
                          {learner.assessmentResult?.levelBFT}
                        </Typography>
                      ) : (
                        <TagComponent text="No BFT" color={COLOR_CONFIG.red} />
                      )}
                    </Row>
                  </div>
                </Row>

                <Row style={{ width: '100%', marginBottom: 24, gap: 24 }}>
                  <div style={{ width: '50%' }}>
                    <InputTitle title="Total training time (minutes)" />

                    <Typography variant="body-2" color={COLOR.surfaceNeutralBold['neutral-11']}>
                      {totalTrainingTime}
                    </Typography>
                  </div>
                </Row>

                {Boolean(learner.classes?.length) && (
                  <Row direction="column" style={{ marginBottom: 24 }}>
                    <InputTitle title="Classes" />
                    <Row
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2,1fr)',
                        gridGap: 12,
                      }}
                    >
                      {learner.classes?.map((el) => (
                        <div
                          style={{
                            border: '1px solid #00000040',
                            borderRadius: 12,
                            padding: '8px 16px 8px 8px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                          }}
                        >
                          <div style={{ width: 60, height: 60 }}>
                            <img
                              src={el.class?.thumbnail ?? ''}
                              alt="class"
                              style={{ width: 60, height: 60, borderRadius: 8, objectFit: 'cover' }}
                            />
                          </div>
                          <div style={{ width: 'calc(100% - 100px)' }}>
                            <Typography variant="body-3" color={COLOR_CONFIG['neutral-text']}>
                              {el.class?.code}
                            </Typography>
                            <Typography
                              variant="body-2"
                              color={COLOR.surfaceNeutralBold['neutral-11']}
                              weight={500}
                            >
                              {el.class?.name}
                            </Typography>
                          </div>
                          <div
                            style={{ width: 24, height: 24, cursor: 'pointer' }}
                            onClick={() => goToCalendar(el.class?.id)}
                          >
                            <ArrowIcon />
                          </div>
                        </div>
                      ))}
                    </Row>
                  </Row>
                )}

                <Row direction="column">
                  <InputTitle title="Functional ability results" />
                  <Row
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(2,1fr)',
                      gridGap: 12,
                    }}
                  >
                    <FunctionalAbilityResult
                      title={'Baseline fitness test'}
                      createdAt={
                        learner?.assessmentResult?.createdAt
                          ? formatDate(learner.assessmentResult.createdAt, 'dd MMM yyyy')
                          : ''
                      }
                      score={learner?.assessmentResult?.totalScore || 0}
                      handleViewHistory={() => handleOpenDrawer('onBoarding')}
                      handleViewDetailHistory={() => handleOpenDrawer('onBoarding', true)}
                    />
                    <FunctionalAbilityResult
                      title={'Functional Mobility Scale'}
                      createdAt={
                        surveyResult?.createdAt
                          ? formatDate(surveyResult?.createdAt, 'dd MMM yyyy')
                          : ''
                      }
                      score={surveyResult?.surveyOption?.index || 0}
                      handleViewHistory={() => handleOpenDrawer('survey')}
                      handleViewDetailHistory={() => handleOpenDrawer('survey', true)}
                    />
                    <FunctionalAbilityResult
                      title={'Clinical Frailty Scale'}
                      createdAt={
                        learner?.cfsResult?.createdAt
                          ? formatDate(learner.cfsResult.createdAt, 'dd MMM yyyy')
                          : ''
                      }
                      score={learner?.cfsResult?.totalScore || 0}
                      handleViewHistory={() => handleOpenDrawer('cfs')}
                      handleViewDetailHistory={() => handleOpenDrawer('cfs', true)}
                    />
                    <FunctionalAbilityResult
                      title={'Falls Risk for Older People'}
                      createdAt={
                        learner?.fropResult?.createdAt
                          ? formatDate(learner.fropResult.createdAt, 'dd MMM yyyy')
                          : ''
                      }
                      score={learner?.fropResult?.totalScore || 0}
                      handleViewHistory={() => handleOpenDrawer('frop')}
                      handleViewDetailHistory={() => handleOpenDrawer('frop', true)}
                    />
                  </Row>
                </Row>
              </Row>
            </ContainerSection>

            <ContainerSection>
              <LearnerProfileForm
                learnerId={learnerId}
                handleChange={handleChange}
                handleChangeMeasurement={handleChangeMeasurement}
                handleChangePhone={handleChangePhone}
                onChangeGender={onChangeGender}
                emailStatus={emailStatus}
                nickname={nickname}
                name={name}
                gender={gender}
                phone={phone}
                dayOfBirth={dayOfBirth}
                monthOfBirth={monthOfBirth}
                yearOfBirth={yearOfBirth}
                bodyFat={bodyFat}
                restingMetabolism={restingMetabolism}
                skeletalMuscle={skeletalMuscle}
                visceralFatLevel={visceralFatLevel}
                email={email ?? ''}
                height={height}
                weight={weight}
                firstName={firstName}
                lastName={lastName}
                handleChangeDate={handleChangeDate}
                disabledField={disabledField}
                onChangeMonths={onChangeMonths}
                onChangeSearchMonths={onChangeSearchMonths}
                searchSelectMonth={searchSelectMonth.value}
                onChangeYears={onChangeYear}
                searchSelectYear={searchSelectYear.value}
                onChangeSearchYears={onChangeSearchYears}
              />
            </ContainerSection>

            {!disabledField && (
              <ContainerSection>
                <TrainerPasswordForm
                  password={password}
                  handleChange={handleChange}
                  disabledField={disabledField}
                  styles={{ width: 800, borderTop: 'none', marginTop: 0, paddingTop: 0 }}
                  title="Mobile app account"
                  confirmPassword={confirmPassword.value}
                  handleConfirmPassword={handleConfirmPassword}
                  hasConfirmPassword
                />
              </ContainerSection>
            )}
          </Row>
        </Row>
      </ContainerForm>
    );
  };

  return (
    <Container direction="column">
      <Spacing spacing="md" type="margin" placement="bottom">
        <HeaderDetailPage title={learner.name} goBack={goBack} style={{ marginBottom: 0 }} />
      </Spacing>
      <CustomTabs style={{ marginBottom: 16 }}>
        <Tabs
          variant="text"
          items={tabs}
          activeKey={activeKey}
          onTabClick={onTabClick}
          tabItemStyle={{
            height: 52,
            background: 'transparent',
          }}
          isLine={true}
        />
      </CustomTabs>

      {renderContent()}
      <Drawer
        open={drawer.survey}
        onClose={() => handleCloseDrawer('survey')}
        direction="right"
        style={{ overflow: 'hidden', width: 'auto' }}
      >
        <SurveyResultDrawer
          visible={drawer.survey}
          learnerId={learnerId!}
          showDetail={drawer.showDetail}
        />
      </Drawer>
      <Drawer
        open={drawer.frop}
        onClose={() => handleCloseDrawer('frop')}
        direction="right"
        style={{ overflow: 'hidden', width: 'auto' }}
      >
        <FropResultDrawer
          visible={drawer.frop}
          learnerId={learnerId!}
          showDetail={drawer.showDetail}
        />
      </Drawer>
      <Drawer
        open={drawer.cfs}
        onClose={() => handleCloseDrawer('cfs')}
        direction="right"
        style={{ overflow: 'hidden', width: 'auto' }}
      >
        <CfsResultDrawer
          visible={drawer.cfs}
          learnerId={learnerId!}
          showDetail={drawer.showDetail}
        />
      </Drawer>
      <Drawer
        open={drawer.onBoarding}
        onClose={() => handleCloseDrawer('onBoarding')}
        direction="right"
        style={{ overflow: 'hidden', width: 'auto' }}
      >
        <OnboardingResultDrawer
          visible={drawer.onBoarding}
          learnerId={learnerId!}
          showDetail={drawer.showDetail}
        />
      </Drawer>
    </Container>
  );
};
